import { Trans } from '@lingui/react/macro';
import { ArrowRight, Desktop, DeviceMobile } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Divider } from 'src/components';
import { IntegrationIcon } from 'src/components/IntegrationIcon';
import { Link2 } from 'src/components/Link2';
import { URLS } from 'src/utils/urls/urls';

export const AppsAndExtensions = () => {
  return (
    <div className="flex flex-col p-16 ll:flex-row">
      <div className="flex flex-1 flex-col gap-16 border-neutral-light-8 text-left ll:flex ll:border-r ll:pr-32">
        <Typography variant="heading-sm">
          <Trans>Take notes from anywhere</Trans>
        </Typography>
        <Typography variant="body-md">
          <Trans>
            View, organize, and import files with our mobile and desktop apps.
            Connect subscribers can also take and edit notes in the apps.
          </Trans>
        </Typography>
        <div className="flex flex-row gap-16">
          <Desktop size={32} className="text-muted" />
          <DeviceMobile size={32} className="text-muted" />
        </div>
        <Link2
          className="font-semibold text-pen-blue"
          to={URLS.DEVICE_APPS}
          componentLocation={ComponentLocations.FRONT_PAGE.APPS_AND_EXTENSIONS}
        >
          <Trans>Download our apps</Trans> <ArrowRight />
        </Link2>
      </div>
      <Divider className="my-16 ll:hidden" />
      <div className="flex flex-1 flex-col gap-16 text-left ll:pl-32">
        <Typography variant="heading-sm">
          <Trans>Sync with cloud storage</Trans>
        </Typography>
        <Typography variant="body-md">
          <Trans>
            Easily access, sync, and store files with cloud storage services
            such as Google Drive, Dropbox, and OneDrive.
          </Trans>
        </Typography>
        <div className="flex flex-row gap-16">
          <IntegrationIcon provider="Dropbox" className="h-32 p-4" />
          <IntegrationIcon provider="GoogleDrive" className="h-32 p-4" />
          <IntegrationIcon provider="OneDrive" className="h-32 p-4" />
        </div>
        <Link2
          className="font-semibold text-pen-blue"
          to={URLS.INTEGRATIONS}
          componentLocation={ComponentLocations.FRONT_PAGE.APPS_AND_EXTENSIONS}
        >
          <Trans>Add integrations</Trans>
          <ArrowRight />
        </Link2>
      </div>
    </div>
  );
};
